/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetTypeDTO } from './target-type-dto';


/**
 * Notification body
 */
export interface NotificationBodyDTO { 
    /**
     * Notification subject
     */
    subject: { [key: string]: string; };
    /**
     * Notification message
     */
    message: { [key: string]: string; };
    targetType: TargetTypeDTO;
    /**
     * Target ID (businessPremisesId, organizationId, tenantId)
     */
    targetId?: string;
    /**
     * Notification readable from date time
     */
    notificationDate?: string;
}

export class ClsNotificationBodyDTO { 
    /**
     * Notification subject
     */
    subject: { [key: string]: string; } = undefined;
    /**
     * Notification message
     */
    message: { [key: string]: string; } = undefined;
    targetType: TargetTypeDTO = undefined;
    /**
     * Target ID (businessPremisesId, organizationId, tenantId)
     */
    targetId?: string = undefined;
    /**
     * Notification readable from date time
     */
    notificationDate?: string = undefined;
}



